import { render, staticRenderFns } from "./DingConnect.vue?vue&type=template&id=63a176f1&scoped=true&"
import script from "./DingConnect.vue?vue&type=script&lang=js&"
export * from "./DingConnect.vue?vue&type=script&lang=js&"
import style0 from "./DingConnect.vue?vue&type=style&index=0&id=63a176f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a176f1",
  null
  
)

export default component.exports